// extracted by extract-css-chunks-webpack-plugin
module.exports = {"comment_box":"comment_box--nEXfdRk","title":"title-llcrjH9g","bg_box":"bg_box-3Ij2wp9K","counts":"counts-K1lf1pIP"};